import { render, staticRenderFns } from "./page-content.vue?vue&type=template&id=38e9c62e&scoped=true&"
import script from "./page-content.vue?vue&type=script&lang=js&"
export * from "./page-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e9c62e",
  null
  
)

export default component.exports